import { ALLOCATIONS, EXPERIMENTS, ROLLOUTS } from '@fiverr-private/listing_experiments';
import { FLOWS } from '../../../utils/constants';

// Scoped to SC/NSC; every other flow and the off state return `eagerImageOffset` downstream, which is byte-identical to today.
export const isSsrGigCountEligible = (flow?: string, rollouts: Record<string, boolean> = {}) =>
    flow === FLOWS.CATEGORY && !!rollouts[ROLLOUTS.CROWS_SSR_GIG_COUNT];

// The rollout is re-checked at render so turning it off disables the experience for already-allocated users.
export const shouldShowSsrGigCount = (
    flow: string,
    abTests: Record<string, number> = {},
    rollouts: Record<string, boolean> = {}
) =>
    isSsrGigCountEligible(flow, rollouts) &&
    Number(abTests[EXPERIMENTS.CROWS_SSR_GIG_COUNT]) > Number(ALLOCATIONS.CONTROL);
